export default function stMinVersionsMet(stCurrent, stMinVersion) {
    let stCurrentSplit = stCurrent.split('.').map(Number)
    let stMinVersionSplit = stMinVersion.split('.').map(Number)
    
    return stMinVersionSplit.every(function (requiredMinVersion, index) {
        return stCurrentSplit[index] >= requiredMinVersion
    })
}